<template>
    <div class="container-fluid">
        <div class="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 class="h3 mb-0 text-gray-800">Video Gallery</h1>
            <router-link to="/video-gallery/add" class="btn btn-primary">
                <i class="pi pi-plus mr-1"></i>Add Videos
            </router-link>
        </div>

        <VideoGalleryList/>
    </div>
</template>

<script>
import {defineComponent} from 'vue'
import VideoGalleryList from '@/components/video-gallery/VideoGalleryList.vue'

export default defineComponent({
    name: "VideoGalleryPage",
    components: {VideoGalleryList}
})
</script>
